import React from 'react';
import 'react-toastify/dist/ReactToastify.css';

import TitleWithIcon from '../components/TitleWithIcon';
import IntegrationList from '../features/Integrations/components/IntegrationList';
import IntegrationRequestButton from '../features/Integrations/components/IntegrationRequestButton';

const Integrations = () => {
  return (
    <div className="sm:flex min-h-screen items-start justify-center bg-gradient-to-r p-2 sm:p-4 from-[#ededed] to-[#dcdcdc]">
      <div className="w-full max-w-sm sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-5xl">
        <TitleWithIcon title={'Интеграции'} />
        {/*<IntegrationRequestButton />*/}
        <IntegrationList />
      </div>
    </div>
  );
};
export default Integrations;
